import { useLayoutEffect, type RefObject } from 'react';

/**
 * Keeps `--scroll-header-h` on a table's scroll container equal to its `<thead>` height, so CSS
 * can start the vertical scrollbar UNDER the sticky header row (`.scroll-under-header`, see
 * utilities.css) instead of beside it. Re-measured whenever the header resizes; a table whose
 * header is not rendered yet (loading) is picked up on the next render.
 */
export function useHeaderScrollOffset(ref: RefObject<HTMLElement | null>): void {
  useLayoutEffect(() => {
    const container = ref.current;
    const head = container?.querySelector('thead');
    if (!container || !head) return;
    const measure = () => {
      container.style.setProperty(
        '--scroll-header-h',
        `${String(head.getBoundingClientRect().height)}px`,
      );
    };
    measure();
    if (typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(measure);
    observer.observe(head);
    return () => {
      observer.disconnect();
    };
  });
}
